const imports = require('./imports.json')
export default imports